import React, { useState, useEffect, useCallback } from 'react';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { alphaNumericSort } from '../../../../util/SortUtil';

import './TableSearch.css';

export const TableSearch = ({
  dataToFilter,
  sortKey,
  isReversed,
  setFilteredData,
  setCurrentPage,
  searchBarWidth,
  inputWidth,
  margin,
  searchIconAlignment,
  hiddenColumns,
  stickyFirstRow,
}) => {
  const [searchString, setSearchString] = useState('');

  const filter = useCallback(() => {
    const filteredData = [];
    dataToFilter.forEach((object, index) => {
      if (stickyFirstRow && index === 0) return;

      let string = '';
      for (const property in object) {
        if (!hiddenColumns.includes(property)) {
          string = string + object[property] + ' ';
        }
      }
      if (string.trim().toLowerCase().includes(searchString.trim().toLowerCase())) {
        filteredData.push(object);
      }
    });
    setCurrentPage(0);
    filteredData.sort((objectOne, objectTwo) => alphaNumericSort(objectOne, objectTwo, sortKey));
    if (isReversed) {
      filteredData.reverse();
    }
    setFilteredData(filteredData);
  }, [dataToFilter, hiddenColumns, searchString, setCurrentPage, setFilteredData, stickyFirstRow, sortKey, isReversed]);

  useEffect(() => {
    if (searchString.length > 0) {
      filter();
    } else {
      if (stickyFirstRow) {
        const copyOfData = [...dataToFilter];
        copyOfData.shift();
        setFilteredData(copyOfData);
      } else {
        const copyOfData = [...dataToFilter];
        copyOfData.sort((objectOne, objectTwo) => alphaNumericSort(objectOne, objectTwo, sortKey));
        if (isReversed) {
          copyOfData.reverse();
        }
        setFilteredData(copyOfData);
      }
    }
  }, [dataToFilter, filter, searchString, setFilteredData, stickyFirstRow, sortKey, isReversed]);

  const handleChange = ({ target }) => {
    setSearchString(target.value);
  };

  return (
    <div className="table-search-container" style={{ width: searchBarWidth, marginLeft: margin }}>
      <FontAwesomeIcon className="search-icon" icon={faSearch} style={{ right: searchIconAlignment }} />
      <input
        style={{ width: inputWidth }}
        data-testid="test-input"
        className="search-text-input"
        placeholder="Search..."
        onChange={handleChange}
      />
    </div>
  );
};
